import React, { useEffect, useState } from 'react'
import Selector from './../../Components/Select/Select'
import { getDocsType } from './../../Service/report'
import { report } from './../../store/report'
import { observer } from 'mobx-react-lite'
import { SelectType } from '../../store/models'
import http from './../../Service/http'
import { accountDocs } from './../../store/accountDocs'

function SearchByName() {
	const [reportType, setReportType] = useState<SelectType>({
		label: 'Все',
		value: 0
	})

	const getReport = async () => {
		const res = await getDocsType()
		accountDocs.newDocsType(res)
	}

	useEffect(() => {
		getReport()
	}, [])

	useEffect(() => {
		const getDocsType = async (id: number) => {
			const a = await http.post('/regis/academDocRegTable', {
				reportType: id,
				s_fio_document: null
			})
			accountDocs.newDocs(a.data.AcademDocRegTable)
		}
		getDocsType(reportType.value)
	}, [reportType])
	return (
		<>
			<div style={{ margin: '0 auto', display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
				<Selector
					options={[
						{
							value: 0,
							label: 'Все'
						},
						...accountDocs.docsType
					]}
					value={reportType}
					placeholder={'Выберите!'}
					onChange={setReportType}
					isSearchable={true}
					isDisabled={false}
					isClearable={false}
					title={''}
					name={'search'}
					withBorder={true}
				/>
			</div>
		</>
	)
}

export default observer(SearchByName)
